module.exports = __webpack_public_path__ + "img/message.720ebe7a.svg";